<template>
    <div
        v-show="visible"
        class="absolute cursor-none pointer-events-none z-30 uppercase transform -translate-y-1/2 -translate-x-1/2"
        :style="{ left: `${cursor.x}px`, top: `${cursor.y}px` }"
    >
        <slot>
            <div class="button w-15 h-15">
                <icon name="arrow" class="w-5 h-5 fill-current" />
            </div>
        </slot>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CustomCursor extends Vue {
    @Prop({ type: String, default: '[data-custom-cursor]' })
    readonly target!: string;

    cursor = { x: 0, y: 0 };
    visible = false;
    targetEl: HTMLElement | null = null;

    mounted() {
        // Find target element(s)
        this.targetEl = this.$el.closest(this.target);

        if (this.targetEl) {
            this.targetEl.addEventListener('mouseenter', this.onMouseEnter);
            this.targetEl.addEventListener('mouseleave', this.onMouseLeave);
        }
    }

    beforeDestroy() {
        if (this.targetEl) {
            this.targetEl.removeEventListener('mouseenter', this.onMouseEnter);
            this.targetEl.removeEventListener('mouseleave', this.onMouseLeave);
        }
        window.removeEventListener('mousemove', this.onMouseMove);
    }

    onMouseEnter() {
        this.visible = true;
        window.addEventListener('mousemove', this.onMouseMove.bind(this));
    }

    onMouseLeave() {
        this.visible = false;
        window.removeEventListener('mousemove', this.onMouseMove.bind(this));
    }

    onMouseMove(event: MouseEvent) {
        if (this.targetEl) {
            this.cursor.x = event.clientX - this.targetEl.getBoundingClientRect().left;
            this.cursor.y = event.clientY - this.targetEl.getBoundingClientRect().top;
        }
    }
}
</script>
